@if (chartId(); as id) {
  <div class="chart-ribbon">
    <cosmos-chart-options-button [chartId]="id" (configChange)="onChartOptionsChange($event)" />
  </div>
}

<cosmos-chart-legend [items]="legendItems" (toggle)="onLegendToggle($event)" />

<div class="chart-wrapper">
    <canvas [id]="'prediction-'+realData()?._id" baseChart
        [data]="chartData"
        [options]="chartOptions"
        [legend]="false"
        [plugins]="chartPlugins"
        [type]="chartType">
    </canvas>
</div>
